import React from 'react'
import Query from 'components/Query'
import { Link } from 'react-router-dom'

const OnlineConsultation = React.memo(({ url }) => {
  return (
    <div className="online-consultation-main-wrapper wow fadeInUp">
      <Query url={url}>
        {({ data }) => (
          <>
            <div className="boxed-border" />
            <div className="section-title">
              <h5>
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/resources/img/sabinehospital-icons/sabinehospital-heartbeat.svg`}
                  alt=""
                />{' '}
                {data.title}
              </h5>
              <div
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: `${data.content.slice(0, 300)}` }}
              />
              <div className="btn-wrapper">
                <Link to="/online-consultation" className="btn big-btn">
                  View All <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </>
        )}
      </Query>
    </div>
  )
});

export default OnlineConsultation
